import { useRouteError } from 'react-router';

import { TRACKING_CATEGORIES } from '#configuration/setup/googleAnalytics.ts';

import ErrorFallback from './ErrorFallback.tsx';

const RouteErrorFallback = () => {
    const error = useRouteError() as Error;
    return (
        <ErrorFallback errorMessage={error.message} trackingCategory={TRACKING_CATEGORIES.ORDER_COMMUNICATION_WEB} />
    );
};

export default RouteErrorFallback;
